<template>
  <div :class="shouldApplyRtl ? 'rtl' : ''">
    <layout />
  </div>
</template>

<script>
import layout from "./components/layout/index.vue";
import { useRoute, useRouter } from "vue-router";
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useHead } from "@vueuse/head";
import { metaConfig } from "./config/meta";

export default {
  name: "App",
  components: {
    layout,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    // Initialize meta with default values
    useHead({
      // Set the title
      title: metaConfig.home.title,
      // Set all meta tags
      meta: [
        // Regular meta tags
        ...metaConfig.home.meta
          .filter((meta) => meta.name)
          .map((meta) => ({
            name: meta.name,
            content: meta.content,
            key: meta.name,
          })),
        // OpenGraph meta tags
        ...metaConfig.home.meta
          .filter((meta) => meta.property)
          .map((meta) => ({
            property: meta.property,
            content: meta.content,
            key: meta.property,
          })),
      ],
      // Set link tags (like canonical)
      link: [
        ...metaConfig.home.meta
          .filter((meta) => meta.rel)
          .map((meta) => ({
            rel: meta.rel,
            href: meta.href,
            key: "canonical",
          })),
      ],
    });

    // Computed property to determine if .rtl should be applied
    const shouldApplyRtl = computed(() => {
      return store.state.isRtl && route.path !== "/brand-signups";
    });

    function openIntercom(data) {
      if (data.intercom_open == 1) window.Intercom("show");
    }

    onMounted(async () => {
      await router.isReady();
      let utm = {};

      if (route.query.utm_source) {
        utm.utm_source = route.query.utm_source;
      }
      if (route.query.utm_medium) {
        utm.utm_medium = route.query.utm_medium;
      }
      if (route.query.utm_campaign) {
        utm.utm_campaign = route.query.utm_campaign;
      }
      /* additional adset and ad */
      if (route.query.adset) {
        utm.adset = route.query.adset;
      }
      if (route.query.ad) {
        utm.ad = route.query.ad;
      }

      /* additional adset and ad */
      store.dispatch("getUTM", utm);

      if (route.query.utm_source) {
        localStorage.setItem("utm_source", route.query.utm_source);
      }
      if (route.query.utm_medium) {
        localStorage.setItem("utm_medium", route.query.utm_medium);
      }
      if (route.query.utm_campaign) {
        localStorage.setItem("utm_campaign", route.query.utm_campaign);
      }
      /* additional adset and add */
      if (route.query.adset) {
        localStorage.setItem("adset", route.query.adset);
      }
      if (route.query.ad) {
        localStorage.setItem("ad", route.query.ad);
      }
      /* additional adset and add */
      await store.dispatch("getGeneralSettings", openIntercom);
    });

    return {
      shouldApplyRtl,
      openIntercom,
    };
  },
};
</script>

<style lang="scss">
@import "./styles/index.scss";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/css/bootstrap.rtl.min.css";
</style>
